


import { Application, Housing } from '@/models';
import { API_URL, FetchApi } from './service';


const URI = `${API_URL}/core/housings/`;



export const HousingsServices = {


  create: (data: Partial<Housing>) =>
    FetchApi.post(`${URI}`, data),


  get: (id: number) =>
    FetchApi.get(`${URI}${id}/`),


  

  list: (params?: any) =>
      FetchApi.get(`${URI}?${new URLSearchParams(params).toString()}`),

  update: (id: number, data: Partial<Housing>) =>
    FetchApi.put(`${URI}${id}/`, data),


  apply: (id: number, data: Partial<Application>) =>
    FetchApi.post(`${URI}${id}/apply/`, data),

  delete: (id: number) =>
    FetchApi.delete(`${URI}${id}/`),

  /**
   * Upload photos for a housing
   *
   * POST /housings/{id}/upload-photos/
   *
   * @param id - ID du logement
   * @param files - Tableau de fichiers images
   * @param captions - Tableau optionnel de légendes
   */
  uploadPhotos: (id: number, files: File[], captions?: string[]) => {
    const formData = new FormData();

    // Ajouter les fichiers
    files.forEach((file) => {
      formData.append('photos', file);
    });

    // Ajouter les légendes si fournies
    if (captions) {
      captions.forEach((caption) => {
        formData.append('captions', caption);
      });
    }

    return FetchApi.postFile(`${URI}${id}/upload-photos/`, formData);
  },

  /**
   * Get all photos for a housing
   *
   * GET /housings/{id}/photos/
   */
  getPhotos: (id: number) =>
    FetchApi.get(`${URI}${id}/photos/`),

  /**
   * Delete a specific photo
   *
   * DELETE /housings/{id}/photos/{photo_id}/
   */
  deletePhoto: (housingId: number, photoId: number) =>
    FetchApi.delete(`${URI}${housingId}/photos/${photoId}/`),

  /**
   * Set a photo as the main photo
   *
   * PUT /housings/{id}/photos/{photo_id}/set-main/
   */
  setMainPhoto: (housingId: number, photoId: number) =>
    FetchApi.put(`${URI}${housingId}/photos/${photoId}/set-main/`, {}),

};
